const BASE_URL = process.env.REACT_APP_API_URL ;

const post = async (endpoint, body) => {
  try {
    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: 'Request failed' }));
      console.error(`API Error [${endpoint}]:`, err);
      // Pass the whole error object so the UI can extract detailed validation messages
      if (err.message) {
        throw new Error(err.message);
      } else {
        // Extract a meaningful message from the error fields (e.g. { loginId: "Invalid LoginId" })
        const meaningfulMsg = Object.entries(err)
          .filter(([k]) => !['timestamp', 'status', 'code', 'statusCode', 'traceId'].includes(k))
          .map(([, v]) => String(v))
          .join(' | ') || 'API Error';
        throw new Error(meaningfulMsg);
      }
    }
    return res.json();
  } catch (error) {
    console.error(`Fetch error [${endpoint}]:`, error);
    throw error;
  }
};

// ── Section 1: Create ABHA ────────────────────────────────────────────────────
export const generateAadhaarOTP = (aadhaar) => post('/generateAadhaarOTP', { aadhaar });
export const verifyAadhaarOTP = (otp, txnId, mobile) => post('/verifyAadhaarOTP', { otp, txnId, mobile });
export const generateMobileOTP = (mobile, txnId) => post('/generateMobileOTP', { mobile, txnId });
export const verifyMobileOTP = (otp, txnId) => post('/verifyMobileOTP', { otp, txnId });
export const createHealthID = (txnId, healthId) => post('/createHealthID', { txnId, healthId });

// ── Section 2: Fetch via Aadhaar (Forgot) ────────────────────────────────────
export const generateForgetAadhaarOtp = (aadhaar) => post('/generateForgetAadhaarOtp', { aadhaar });
export const verifyForgetAadhaarOtp = (otp, txnId) => post('/verifyForgetAadhaarOtp', { otp, txnId });

// ── Section 3: Fetch via Mobile ───────────────────────────────────────────────
export const generateForgetMobileOtp = (mobile) => post('/generateForgetMobileOtp', { mobile });
export const verifyForgetMobileOtp = (otp, txnId) => post('/verifyForgetMobileOtp', { otp, txnId });

// ── Section 4: Fetch via ABHA Address ────────────────────────────────────────
export const generateAbhaAddressOtp = (abhaAddress) => post('/generateAbhaAddressOtp', { abhaAddress });
export const verifyAbhaAddressOtp = (otp, txnId) => post('/verifyAbhaAddressOtp', { otp, txnId });

// ── Section 5: Authenticate via ABHA Number ───────────────────────────────────
export const generateAuthOtp = (healthid) => post('/generateAuthOtp', { healthid });
export const verifyAuthOtp = (otp, txnId) => post('/verifyAuthOtp', { otp, txnId });

// ── Section 6: Get PNG Card ──────────────────────────────────────────────────
export const getPngCard = (token) => post('/getPngCard', { token });
